/**
 *
 * 菜单状态管理
 *
 * */
const state = {
  mainMenuId: '', // 二级导航ID(主导航)
  menuId: '' // 三级导航ID

}

// getters
const getters = {}

// 处理方法
const actions = {
  getItemMenu ({ commit }, obj) {
    commit('setItemMenu', obj)
  }
}

// mutations
const mutations = {
  setItemMenu (state, obj) {
    if (obj.mainMenuId) {
      state.mainMenuId = obj.mainMenuId
    }
    if (obj.menuId) {
      state.menuId = obj.menuId
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js